import "./MCUActors.css";
import "../Common.css"

import AsyncSelect from 'react-select/async';
import {SingleValue, ActionMeta} from 'react-select';
import { useState } from "react";
import {Link} from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';
import { couldStartTrivia } from "typescript";
//import SingleValue from "react-select/dist/declarations/src/components/SingleValue";
import arrayOfCharacters from './characters.json';

import ActorList from "./ActorList"

type characterArray = {
    id:string,
    name:string,
    profile_path:string,
    films:MovieRole[]
}

type MatchProps = {
    id: string,
    character: string
}

type ResultProps2 = {
    credit: {
        cast: MatchProps[]
    }
};

type ResultProps = {
    id:number,
    title:string,
    release_date:string
};

type DisplayProps = {
    value:string,
    label:string
};

type ActorRole = {
    id:string,
    name:string,
    character:string,
    movies:MovieRole[]
}

type MovieRole = {
    title:string,
    character:string
}


function MCUActors()
{
    //const [options, setOptions] = useState<DisplayProps[]>([]);
    const [options, setOptions] = useState<DisplayProps[]>([]);
    const [movieID, setMovieID] = useState("");
    const [matches, setMatches] = useState<ActorRole[]>([]);
    const [title, setTitle] = useState<string>("");
//    const [matches, setMatches] = useState<MatchProps[]>([]);

    const promiseOptions = async (query:string) => {
        const data = await fetch(`https://api.themoviedb.org/3/search/movie?api_key=4237307735295a0d8ffbe8672656f5ae&language=en-US&query=${query}`);
        const dataJ = await data.json(); // fetching data from API in JSON Format
        //console.log(data);
        //console.log(dataJ);
        //console.log(dataJ.results);
        //const obj = JSON.parse(dataJ);
        //console.log(dataJ);

        const newOptions:DisplayProps[] = dataJ.results.map((result:ResultProps) => ({
            value: result.id,
            label: `${result.title} (${new Date(result.release_date).getFullYear()})`
            })
        );
        //console.log(newOptions);    
        
        //const newOptions:ResultProps[] = dataJ.results.map((result:ResultProps) => ({id:result.id,title:result.title,release_date:result.release_date})
        //);
        //console.log(newOptions);

        //setOptions(newOptions);
        //console.log(options);
        //setVal(5);
        //console.log(val);

        return newOptions;
    };

    // const updateOptions = async (query:string) => {
    //     const newOptions = await updateOptions2(query);
    //     setOptions(newOptions);
    // }

    const matchRow = (match:MatchProps):ActorRole => {
        const result:ActorRole = {
            id: match.id,
            name: arrayOfCharacters[match.id as keyof typeof arrayOfCharacters].name,
            character: match.character,
            movies: arrayOfCharacters[match.id as keyof typeof arrayOfCharacters].films
        };

        return result;
    }

    const handleTitleSelect = (newValue: SingleValue<DisplayProps>, actionMeta: ActionMeta<DisplayProps> ) => {
        if(newValue)
        {
            // const dataJ = fetch(`https://api.themoviedb.org/3/movie/${newValue.value}?api_key=4237307735295a0d8ffbe8672656f5ae&language=en-US&append_to_response=credits`)
            // .then((res) => res.json())
            // .then((data)=>{
            //     setMatches(
            //         data.credits.cast
            //         .filter(
            //             (result:MatchProps) => {
            //                 return arrayOfCharacters.hasOwnProperty(result.id);
            //                 //return arrayOfCharacters.filter(res=>{return result.id === res.id}).length > 0
            //             }
            //         )
            //         .map(
            //             (match:MatchProps)=>(
            //                 {
            //                     id:match.id,
            //                     character:match.character
            //                 }
            //             )
            //         ))
            // });

            const dataJ = fetch(`https://api.themoviedb.org/3/movie/${newValue.value}?api_key=4237307735295a0d8ffbe8672656f5ae&language=en-US&append_to_response=credits`)
            .then((res) => res.json())
            .then((data)=>{
                setMatches(
                    data.credits.cast
                    .filter(
                        (result:MatchProps) => {
                            return arrayOfCharacters.hasOwnProperty(result.id);
                            //return arrayOfCharacters.filter(res=>{return result.id === res.id}).length > 0
                        }
                    )
                    .map(
                        (match:MatchProps)=>(
                            matchRow(match)
                        )
                    ));
                    setTitle(newValue.value);
            });
        }
    };

    return (
        <div className="top-buffer">
            <Container>
                <Row>
                    <Col md={{ span: 2, offset: 1 }}>
                        <p className="query">
                            Search query:
                        </p>
                    </Col>
                    <Col md={4}>
                        <AsyncSelect loadOptions={promiseOptions} onChange={handleTitleSelect}/>
                    </Col>
                </Row>
                <Row>
                    <ActorList title={title} matches={matches} />
                </Row>
            </Container>
            <Link to="/Home" className="logo"></Link>
        </div>
      )
}

export default MCUActors